// @flow

import * as type from './types'
import { createAction } from 'redux-actions'
// Types
import type { Action } from '../../util/redux'
import type { UserPreference } from '@rachio-npm/com-rachio-web-core/types/user/userPreference'

/**
 * A module containing action documentation and action
 * creator methods related to Users
 * @module
 * @requires module:types
 */

/**
 * Create login init action
 * @returns {LoginInitAction} - action
 */
export const loginInit = createAction(type.LOGIN_INIT)

/**
 * Create login complete action
 * @returns {LoginCompleteAction} - action
 */
export const loginComplete = createAction(type.LOGIN_COMPLETE)

/**
 * Create logout action
 * @returns {LogoutAction} - action
 */
export const logout = createAction(type.LOGOUT)

/**
 * Create user create init action
 * @param {Object} userData - Data for user being requested
 * @returns {UserRequstInitAction} - action
 */
export const userCreateInit = createAction(type.USER_CREATE_INIT)

/**
 * Create user create complete action
 * @param {Object} userData - Id of user being requested
 * @param {User} data - User data
 * @returns {UserCompleteAction} - action
 */
export const userCreateComplete = createAction(type.USER_CREATE_COMPLETE)

/**
 * Create user request init action
 * @param {string} userId - Id of user being requested
 * @returns {UserRequstInitAction} - action
 */
export const userRequestInit = createAction(type.USER_REQUEST_INIT)

/**
 * Create user request complete action
 * @param {string} userId - Id of user being requested
 * @param {User} data - User data
 * @returns {UserRequstCompleteAction} - action
 */
export const userRequestComplete = createAction(type.USER_REQUEST_COMPLETE)

/**
 * Create user update init action
 * @param {string} userId - Id of user being requested
 * @param {Object} updateObj - User data to update
 * @returns {UserUpdateInitAction} - action
 */
export const userUpdateInit = createAction(type.USER_UPDATE_INIT)

export const set = createAction(type.UPDATE)

/**
 * Create user update complete action
 * @param {string} userId - Id of user being requested
 * @param {User} data - User data
 * @returns {UserUpdateCompleteAction} - action
 */
export const userUpdateComplete = createAction(type.USER_UPDATE_COMPLETE)

/**
 * Create user invalidate data action
 * @function
 */
export const userInvalidateData = createAction(type.USER_INVALIDATE_DATA)

/**
 * Create user invalidate data action
 * @function
 */
export const userAddEvent = createAction(type.USER_ADD_EVENT)

export const addLocation = createAction(type.ADD_LOCATION)
export const removeLocation = createAction(type.REMOVE_LOCATION)

/**
 * Create actions for listing locations for a given device
 * @function
 */
export const getLocationsInit = createAction(type.GET_LOCATIONS_INIT)
export const getLocationsComplete = createAction(type.GET_LOCATIONS_COMPLETE)

/**
 * Create actions for listing locations for a given device
 * @function
 */
export const getDevicesInit = createAction(type.GET_DEVICES_INIT)
export const setDevicesIds = createAction(type.SET_DEVICES_IDS)
export const getDevicesComplete = createAction(type.GET_DEVICES_COMPLETE)

// Public API key
export const getApiKeyInit = createAction(type.GET_API_KEY_INIT)
export const getApiKeyComplete = createAction(type.GET_API_KEY_COMPLETE)

/**
 * Create actions for getting a single preference
 * @function
 */
type GetPreferenceInitCreator = GetPreferenceInitData => GetPreferenceCompleteAction
type GetPreferenceCompleteCreator = GetPreferenceCompleteData => GetPreferenceCompleteAction
type GetPreferenceInitData = { userId: string, preferenceName: string }
type GetPreferenceCompleteData = { ...UserPreference, userId: string } | Error
export type GetPreferenceInitAction = {
  ...Action,
  payload: GetPreferenceInitData,
  type: 'GET_PREFERENCE_INIT'
}
export type GetPreferenceCompleteAction = {
  ...Action,
  type: 'GET_PREFERENCE_COMPLETE',
  payload: GetPreferenceInitData
}
export const getPreferenceInit: GetPreferenceInitCreator = createAction(
  type.GET_PREFERENCE_INIT
)
export const setPreference = createAction(type.SET_PREFERENCE)
export const getPreferenceComplete: GetPreferenceCompleteCreator = createAction(
  type.GET_PREFERENCE_COMPLETE
)

/**
 * Create actions for updating user password
 * @function
 */
export const updatePasswordComplete = createAction(
  type.UPDATE_PASSWORD_COMPLETE
)
export const updatePasswordInit = createAction(type.UPDATE_PASSWORD_INIT)

// Using as another user //////////////

type MaskAsUserAction = {
  ...Action,
  type: 'MASK_AS_USER',
  payload: { userId: string }
}
export const maskAsUser: ({
  userId: string
}) => MaskAsUserAction = createAction(type.MASK_AS_USER)
